export const _LOAD_MODEL_ = 'Load:ProductModel';
export const _RELOAD_TYPE_ = 'Reload:ProductType';
export const _LOAD_EQUIPMENT_ = 'Load:Equipment';
export const _RELOAD_EQUIPMENT_ = 'Reload:Equipment';

export const _DELETE_PRODUCT_ = 'Delete:Product';
export const _DELETE_PRODUCT_EQUIPMENT_ = 'Delete:Equipment';

export const SAVE_EQUIPMENT_REQUEST = 'Save:EquipmentPageProducts';
export const SEARCH_EQUIPMENTS = 'Search:EquipmentsPageProducts';

export const _SAVE_PRODUCT_SUCCESS_ = 'Save:ProductSuccess';

export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  price: null,
  type_id: 1,
  type: {
    id: 1,
    name: 'Vibração',
    slug: 'vibration',
  },
  method: null,
  method_nr15: null,
  code: null,
  code_nr15: null,
  cas: null,
  action_in_body: null,
  ipvs: null,
  notion_skin: null,
  odor_limit: null,
  respirator: null,
  equipments: [],
};
